import { useState, useEffect } from "react";
import { adjacencySettingsService } from "../../services/AdjacencySettingsService";

function useAdjacencySettings(page: number | undefined): [any, boolean] {
  const [result, setResult] = useState({
    channels: [],
    hasMore: true,
    cursor: "",
    total: 0,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        if (result.hasMore) {
          setLoading(true);
          const res = await adjacencySettingsService.getAll(page ? page : 1);
          if (res.status !== 200) {
            throw new Error("Failed to fetch!");
          } else {
            setResult(res.data);
          }
        }
      } catch (err: any) {
        const error = err.toString();
        //message.error(error);
        console.log(error)
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return [result, loading];
}

export default useAdjacencySettings;
